import React from 'react';
import 'react-app-polyfill/stable';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'core-js/actual/promise/finally';
import { PersistGate } from 'redux-persist/lib/integration/react';
import { createBaseGainsightProvider } from '@rsos/capstone';
import '@rsos/capstone/src/overridePublicPath';
import ErrorBoundary from '@rsos/components/capstone/ErrorBoundary';
import NotFound from '@rsos/components/capstone/ErrorBoundary/NotFound';
import Layout from '@rsos/components/capstone/Layout';
import { FlagProvider } from '@rsos/flags';
import { gspx } from '@rsos/gainsight';
import { captureExceptionWithScope } from '@rsos/utils/sentry';
import App from './app/App';
import { store, persistor } from './store';

// Initialize Gainsight with data provider and error handling
const dataProvider = {
  ...createBaseGainsightProvider(store),
  // PSAP Management app doesn't handle call data
  getSelectedCallData: () => null,
};
gspx.initialize(dataProvider, {
  captureError: captureExceptionWithScope,
});

const topLevelRoutes = [
  {
    path: 'admin/psap',
    component: <App />,
  },
];

const AppRoutes = () => (
  <Routes>
    {topLevelRoutes.map(({ path, component, ...rest }) => (
      <Route key={path} path={path} element={component} {...rest} />
    ))}
    <Route path="*" element={<NotFound />} />
  </Routes>
);

const container = document.getElementById('root');

const root = createRoot(container);

root.render(
  <Provider store={store}>
    <FlagProvider>
      <PersistGate loading={'Loading'} persistor={persistor}>
        <BrowserRouter>
          <Layout
            appPaths={topLevelRoutes.map(route => route.path)}
            persistor={persistor}
          >
            <ErrorBoundary>
              <AppRoutes />
            </ErrorBoundary>
          </Layout>
        </BrowserRouter>
      </PersistGate>
    </FlagProvider>
  </Provider>,
);
